import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import {
  ErrorMessageEntities,
  ModalMessageEntities,
  Snackbar
} from "@/domain/entities/MainApp";
import { storeDatatoLocalStorage } from "@/app/infrastructures/misc/LocalStorage";

export interface MainAppState {
  errorMessageModal: boolean;
  errorMessageEntities: ErrorMessageEntities;
  messageModal: boolean;
  messageEntities: ModalMessageEntities;
  loadingModal: boolean;
  loadingMessage: string;
}

@Module({ namespaced: true, dynamic: true, store, name: "app-layout" })
class MainAppStore extends VuexModule implements MainAppState {
  // error message
  errorMessageModal = false;
  responseModal = false;
  errorMessageEntities = new ErrorMessageEntities();
  isSidebarAndBreadcrumbV2 = false;
  @Action
  showErrorMessage(params: ErrorMessageEntities) {
    this.setErrorMessageEntities(params);
    this.setOpenErrorMessage(true);
  }
  @Action
  closeErrorMessage() {
    this.setErrorMessageEntities(new ErrorMessageEntities());
    this.setOpenErrorMessage(false);
  }
  @Mutation
  setOpenErrorMessage(bool: boolean) {
    this.errorMessageModal = bool;
  }
  @Mutation
  showResponseModal() {
    this.responseModal = true;
  }
  @Mutation
  closeResponseModal() {
    this.responseModal = false;
  }
  @Mutation
  setErrorMessageEntities(error: ErrorMessageEntities) {
    this.errorMessageEntities = error;
  }

  // modal message
  messageModal = false;
  messageEntities = new ModalMessageEntities();
  @Action
  showMessageModal(params: ModalMessageEntities) {
    this.setMessageEntities(params);
    this.setOpenMessageModal(true);
  }
  @Action
  closeMessageModal() {
    this.setMessageEntities(new ModalMessageEntities());
    this.setOpenMessageModal(false);
  }
  @Mutation
  setOpenMessageModal(bool: boolean) {
    this.messageModal = bool;
  }
  @Mutation
  setMessageEntities(data: ModalMessageEntities) {
    this.messageEntities = data;
  }

  // loading
  loadingModal = false;
  loadingMessage = "";
  @Action
  showLoading(message = "") {
    this.setLoadingMessage(message);
    this.setLoadingModal(true);
  }
  @Action
  closeLoading() {
    this.setLoadingMessage();
    this.setLoadingModal(false);
  }
  @Mutation
  setLoadingModal(bool: boolean) {
    this.loadingModal = bool;
  }
  @Mutation
  setLoadingMessage(message = "") {
    this.loadingMessage = message;
  }

  // snackbar
  snackbar = false;
  snackbarMessage = "";
  snackbarPositive = true;
  snackbarTimeout = 0;
  snackbarAutoClose = false;
  snackbarBackgroundColor = "";
  snackbarIconLeft = "";
  @Mutation
  setSnackbar(bool: boolean) {
    this.snackbar = bool;
  }
  @Mutation
  setSnackbarMessage(val: string) {
    this.snackbarMessage = val;
  }
  @Mutation
  setSnackbarPositivity(val: boolean) {
    this.snackbarPositive = val;
  }
  @Mutation
  setSnackbarTimeout(val: number) {
    this.snackbarTimeout = val;
  }
  @Mutation
  setAutoClose(val: boolean) {
    this.snackbarAutoClose = val;
  }
  @Mutation
  setSnackbarBackgroundColor(val: string) {
    this.snackbarBackgroundColor = val;
  }

  @Mutation
  setSnackbarIconLeft(val: string) {
    this.snackbarIconLeft = val;
  }

  snackbarRerenderKey = 0;
  @Mutation // harus menggunakan $nextTick setelah memanggil ini
  setSnackbarRerender() {
    this.snackbarRerenderKey++;
  }

  snackbarData = new Snackbar();
  @Mutation
  setSnackbarData(data = new Snackbar()) {
    this.snackbarData = data;
  }

  // screen size
  public screenSize = window.screen;

  @Mutation
  setSidebarAndBreadcrumbV2(value: boolean) {
    this.isSidebarAndBreadcrumbV2 = value;
    storeDatatoLocalStorage("is-sidebar-and-breadcrumb-v2", value);
  }

  showIconNotificationMenuSidebar = false;
  @Mutation
  setShowIconNotificationMenuSidebar(val: boolean) {
    this.showIconNotificationMenuSidebar = val;
  }

  // Account Alerts
  accountAlerts: any[] = [];
  @Mutation
  setAccountAlerts(alerts: any[]) {
    this.accountAlerts = alerts;
  }
  @Mutation
  addAccountAlert(alert: any) {
    const exists = this.accountAlerts.find(a => a.id === alert.id);
    if (!exists) {
      this.accountAlerts.push(alert);
    }
  }
  @Mutation
  removeAccountAlert(id: string | number) {
    this.accountAlerts = this.accountAlerts.filter(a => a.id !== id);
  }
}

export const MainAppController = getModule(MainAppStore);
